// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.3.0",
  date: "2026-07-15T14:09:48.534Z",
  gitInfo: {
    dirty: false,
    raw: "613079fb8",
    hash: "613079fb8",
    distance: null,
    tag: null,
    semver: null,
    suffix: "613079fb8",
    semverString: null
  }
};
/* tslint:enable */
